// Global Imports
import * as React from "react";
// Controls
import { IconIndicator } from "./IconIndicator";
// Style
import { useTheme } from "@fluentui/react";
import { myDayRegularSmallIconProps } from "../../../icons/icons.styles";
import { getBaseIndicatorStyles } from "./Indicators.styles";
/**
 * My Day Indicator component that renders an icon indicating task was added to My Day
 */ export const MyDayIndicator = (props)=>{
    const theme = useTheme();
    const styles = getBaseIndicatorStyles(theme);
    return /*#__PURE__*/ React.createElement("div", {
        className: "myday indicator",
        title: props.ariaLabel
    }, /*#__PURE__*/ React.createElement(IconIndicator, {
        ...props,
        ariaLabel: props.ariaLabel,
        iconProps: myDayRegularSmallIconProps,
        styles: styles
    }));
};
